/* eslint-disable indent */
class EmailService {
    $scope: any
    alerts: any
    translationService: any
    constructor(alerts: AlertService, translationService: any) {
        this.alerts = alerts
        this.translationService = translationService
        this.clearEmailFields = this.clearEmailFields.bind(this)
        this.emailSuccess = this.emailSuccess.bind(this)
        this.emailError = this.emailError.bind(this)
        this.print = this.print.bind(this)
        this.isFormInvalid = this.isFormInvalid.bind(this)
        this.isEmailInvalid = this.isEmailInvalid.bind(this)

    }

    clearEmailFields(scope: any) {
        scope.recipient = ""
        scope.message = ""
        scope.sender = ""
        return scope.emailForm.$setPristine()
    }

    emailSuccess(scope: any) {
        this.alerts.pulseAlert('emailNotify', this.translationService.translations.EMAIL_SENT_SUCCESSFULLY)
        scope.isSending = false
        return this.clearEmailFields(scope)
    }

    emailError(response: any, typeAlert: string, scope: any) {
        const code = response.status
        const msg = (() => {
            switch (code) {
                case 422: return response.data
                default: return 'Email processing error.' // 422 Unprocessable entity
            }
        })()
        scope.isSending = false
        scope.translationParams =
            { email_address: scope.recipient }
        return this.alerts.setAlert(typeAlert, msg)
    }

    print() {
        const screen_media = $('.screen-media-wrapper')
        const print_media = $('.print-media-wrapper')
        const printable = $('.printable:visible').clone()

        const close = $('<button class="hide-print btn btn-default">Close</button>')
        close.on('click', function () {
            print_media.hide()
            print_media.empty()
            screen_media.show()
            // trigger a resize on the window to reset the layout
            return $(window).resize()
        })

        print_media.hide()
        print_media.append(close)
        print_media.append(printable)
        screen_media.hide()
        print_media.show()
        return setTimeout(window.print, 10)
    }

    isFormInvalid(emailForm: any) {
        return (this.isEmailInvalid(emailForm, 'recipient') && emailForm.recipient?.$dirty) ||
      (this.isEmailInvalid(emailForm, 'sender') && emailForm.sender.$dirty)
    }

    isEmailInvalid(emailForm: any, type: string) {
        return emailForm && emailForm[type] && (emailForm[type].$error.email || emailForm[type].$error.required)
     }

}

EmailService.$inject = ['alertService', 'translationService']


angular.module('summonApp.services')
    .service('emailService', EmailService)
